<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-card-group(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="brands/windows", scale="2")
            span Windows
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center
              div.text-nowrap {{$t('agent')}}
              div.d-flex.flex-wrap.agent-button-container
                b-button.agent_download_button(size="sm", @click='openInstallerModal') {{$t('auto_install_multiple')}}
                b-button.agent_download_button(size="sm", type="button", variant="secondary", target="_blank", :href="generateUrl(`${agent}/linkmeminese_windows_agent_setup.exe`)", download) {{$t('single_agent_install')}}
      
      b-card-group.mt-2(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="brands/apple", scale="2")
            span MacOS
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center(style="border-bottom: 1px solid rgba(0, 0, 0, 0.125); border-radius: 0") {{$t('agent')}} ({{($t('remote_device'))}})
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${agent}/linkmeminese_mac_agent_setup.zip`", download) {{$t('download')}}
      b-card-group.mt-2(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="brands/android", scale="2")
            span Android
          b-list-group
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} ({{($t('remote_device'))}})
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${agent}/linkmeminese_android_agent_setup.apk`", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} (KICC CS-273N)
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${agent}/linkmeminese_android_agent_kicc.apk`", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} (KICC CS-124A)
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${agent}/linkmeminese_android_agent_kicc_cs124a.apk`", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} (KICC CTD-6000)
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${agent}/linkmeminese_android_agent_rockchip.apk`", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('agent')}} (KICC CTD-7000)
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${agent}/linkmeminese_android_agent_kicc_ctd7000.apk`", download) {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('android')}} ({{($t('viewer'))}})
              b-button(size="sm", type="button", variant="secondary", target="_blank", href="https://play.google.com/store/apps/details?id=com.linkmemine.manager.se") Link
      b-card-group.mt-2(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="mobile", scale="2")
            span iOS
          b-list-group(flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center iOS {{($t('viewer'))}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", href="https://apps.apple.com/sa/app/linkmeminese-manager/id6505130939") Link
      b-card-group.mt-2(deck)
        b-card.ml-1.mr-1(no-body)
          div.download-header(slot="header")
            icon(name="regular/file", scale="1.4")
            span ETC
          b-list-group(v-if='accountType === 0' flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('support_page.remote_access_manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${manual}/${fileNames.remoteAccessManual}.pdf?v=${cacheBuster}`") {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('support_page.remote_management_manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${manual}/${fileNames.remoteManagementManual}.pdf?v=${cacheBuster}`") {{$t('download')}}
          b-list-group(v-if='accountType === 1' flush)
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('support_page.remote_access_manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${manual}/${fileNames.remoteAccessManualCorporate}.pdf?v=${cacheBuster}`") {{$t('download')}}
            b-list-group-item.d-flex.justify-content-between.align-items-center {{$t('support_page.remote_management_manual')}}
              b-button(size="sm", type="button", variant="secondary", target="_blank", :href="`${manual}/${fileNames.remoteManagementManualCorporate}.pdf?v=${cacheBuster}`") {{$t('download')}}
      agent-installer-dialog(@confirmed="handleInstallerResult")
</template>

<script>
import { getCurrentLanguage } from "@/i18n"
import store from '@/api/store'
import Appstate from '@/plugins/appstate'
import AgentInstallerDialog from '@/components/support/components/AgentInstallerDialog.vue'
import CryptoJS from 'crypto-js'

const AES_KEY = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_AES_SECRET_KEY)
const AES_IV = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_AES_IV)
export default {
  name: "downloads-component",
  components: {AgentInstallerDialog},
  methods: {
    onWork() {
      this.AppState.$emit("lmm-message-dialog", {
        title: "LinkMeMine",
        context: { path: "on_working" },
      })
    },
    openInstallerModal() {
      this.$root.$emit('bv::show::modal', 'agent-installer-dialog')
    },
    handleInstallerResult(data) {
      const type = data.installType === 'autoInstall' ? 'on' : 'off'
      const formattedExpireDate = data.expireDate.split('-').join('')
      const proxyServer = data.proxyServer || '0'
      const proxyPort = data.proxyPort || '0'
      const proxyId = data.proxyId
      const proxyPassword = data.proxyPassword
      const port = '443'
      
      let strData = `${type};${Appstate.Path.origin};${port};${data.id};${data.password};${formattedExpireDate};${proxyServer};${proxyPort}`

      if (proxyId && proxyPassword) {
        strData += `;${proxyId};${proxyPassword}`
      }

      const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(strData), AES_KEY,
          { iv: AES_IV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
      )
      const encoded = encrypted.ciphertext.toString(CryptoJS.enc.Base64)
          .replace(/\+/g, '-')
          .replace(/\//g, '_')
          .replace(/=+$/g, '')
      const baseFilename = `${encoded}.exe`
      const originalUrl = `${this.agent}/linkmeminese_windows_agent_auto_setup.exe`
      const downloadUrl = this.generateUrl(originalUrl)
      
      fetch(downloadUrl)
          .then(res => res.blob())
          .then(blob => {
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = baseFilename
            a.click()
            URL.revokeObjectURL(a.href)
          })
          .catch(err => {
            this.$awn.warning(this.$t('file_download_error'))
          })
    },
    generateUrl(baseUrl) {
      return `${baseUrl}?timestamp=${new Date().getTime()}`
    },
  },
  computed: {
    accountType() {
      return store.get('auth').account_type
    },
    cacheBuster() {
      return new Date().getTime(); // 현재 타임스탬프를 캐시버스터로 사용
    },
    fileNames() {
      const lang = getCurrentLanguage()
      
      const manualNames = {
        ko: {
          remoteAccessManual: "원격접속_매뉴얼",
          remoteManagementManual: "원격관리[설치]_매뉴얼",
          remoteAccessManualCorporate: "원격접속_매뉴얼_기업향",
          remoteManagementManualCorporate: "원격관리[설치]_매뉴얼_기업향",
        },
        en: {
          remoteAccessManual: "Remote Access Manual",
          remoteManagementManual: "Remote Management Manual",
          remoteAccessManualCorporate: "Enterprise Remote Access Manual",
          remoteManagementManualCorporate: "Enterprise Remote Management Manual",
        },
        jp: {
          remoteAccessManual: "リモートアクセス_マニュアル",
          remoteManagementManual: "リモート管理[インストール]_マニュアル",
          remoteAccessManualCorporate: "リモートアクセス_マニュアル_企業用",
          remoteManagementManualCorporate: "リモート管理[インストール]_マニュアル_企業用",
        },
        default: {
          remoteAccessManual: "원격접속_매뉴얼",
          remoteManagementManual: "원격관리[설치]_매뉴얼",
          remoteAccessManualCorporate: "원격접속_매뉴얼_기업향",
          remoteManagementManualCorporate: "원격관리[설치]_매뉴얼_기업향",
        },
      }
      
      return manualNames[lang] || manualNames.default
    }
  },
  data() {
    let lang = getCurrentLanguage()
    if (lang === "ko") lang = "kr"
    return {
      agent: `${this.AppState.Path.download}/agent`,
      manual: `${this.AppState.Path.download}/manual/${lang}`,
    }
  },
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 0;
  > .card-header {
    border-bottom: 1px solid #d2d2d2;
    font-size: 1.2rem;
    font-weight: 500;
  }
}

.btn-secondary {
  color: black !important;
  font-weight: 400;
  height: 1.5rem;
  width: 6rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #f7f7f7 !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #cbcbcb !important;
  border: 1px solid #9c9c9c !important;
  font-weight: 400;
  > svg {
    color: black;
  }
}

.fa-icon {
  position: relative;
  margin-right: 1rem;
  color: #6f6f6f;
}

.download-header span {
  position: relative;
  top: 0.25rem;
}

.list-group-item {
  border-bottom: none;
}

.agent-button-container {
  gap: 0.5rem;
  justify-content: flex-end;
}

.agent_download_button {
  white-space: nowrap;
  width: auto;
}
</style>
